import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { useSelector } from 'react-redux';
import appConfig from '../../config/appConfig';
import { isSubscriptionUsageLimitReached } from '../../utils/subscriptionUsage';

const useSubscriptionCheck = () => {
  const navigate = useNavigate();
  const subscription = useSelector((state) => state.subscription.subscription);
  const user = useSelector((state) => state.user.user);
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 580,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px',
  };

  const checkSubscription = () => {
    if (subscription?.status === 'past_due') {
      setModalType('overdue');
      setOpenModal(true);
      return false;
    }
    if (subscription?.status !== 'active') {
      setModalType('noActiveSubscription');
      setOpenModal(true);
      return false;
    }

    if (isSubscriptionUsageLimitReached(subscription)) {
      setModalType('limitReached');
      setOpenModal(true);
      return false;
    }

    return true;
  };

  const SubscriptionModal = () => (
    <Modal open={openModal} onClose={() => setOpenModal(false)} className="backdrop-model" disableScrollLock>
      <Box sx={modalStyle}>
        {modalType === 'overdue' ? (
          <>
            <Typography variant="h6" component="h2" gutterBottom>
              Oops! Payment Due
            </Typography>
            <Typography variant="body1" gutterBottom>
              Looks like your invoice is overdue. Kindly clear the outstanding amount to continue.
            </Typography>
          </>
        ) : modalType === 'limitReached' ? (
          <>
            <Typography variant="h6" component="h2" gutterBottom>
              Invoice Usage Limit Reached
            </Typography>
            <Typography variant="body1" gutterBottom>
              You&#39;ve used up your invoice quota for this period. Upgrade your subscription to continue seamless
              access.
            </Typography>
          </>
        ) : modalType === 'noActiveSubscription' ? (
          <>
            <Typography variant="h6" component="h2" gutterBottom>
              No Active Subscription
            </Typography>
            <Typography variant="body1" gutterBottom>
              No active subscription. Please reach out to{' '}
              {subscription?.is_from_partner ? subscription?.partner_org_email : appConfig.brandEmail}.
            </Typography>
          </>
        ) : null}
        <Box mt={2} display="flex" justifyContent="space-between">
          {!subscription?.is_from_partner && user?.is_root_user && (
            <Button
              variant="contained"
              onClick={() => {
                setOpenModal(false);
                navigate('/settings?tab=subscription');
              }}
              sx={{ marginLeft: 'auto' }}
            >
              Manage Subscription
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );

  return { checkSubscription, SubscriptionModal };
};

export default useSubscriptionCheck;
